import {fonts} from '../../../theme/foundations/fonts'
import {pxToRem} from '../../../utills/pxToRem'

export const headerWrapper = {
    paddingTop: [pxToRem(20), pxToRem(20), pxToRem(23), pxToRem(23)],
    paddingBottom: [pxToRem(20), pxToRem(20), pxToRem(23), pxToRem(23)],
    paddingLeft: [pxToRem(11), pxToRem(11), pxToRem(45), pxToRem(45)],
    paddingRight: [pxToRem(11), pxToRem(11), pxToRem(45), pxToRem(45)]
}

export const logoImage = {
    height: [[pxToRem(20)], [pxToRem(20)], [pxToRem(34)], [pxToRem(34)]],
    color: 'white'
}

export const cartImage = {
    width: [pxToRem(24), pxToRem(24), pxToRem(24), pxToRem(24)],
    height: [pxToRem(24), pxToRem(24), pxToRem(24), pxToRem(24)],
    color: 'white'
}

export const backButton = {
    color: 'white',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    '.chakra-button__icon': {
        marginLeft: [pxToRem(0), pxToRem(0), pxToRem(5), pxToRem(5)]
    }
}
